import { createApi } from '@reduxjs/toolkit/query/react'
import type { LoyaltyTierApiResponse } from '@/types/loyalty'
import { playerBaseQuery } from './playerBaseQuery'

export const loyaltyApi = createApi({
	reducerPath: 'loyaltyApi',
	baseQuery: playerBaseQuery,
	tagTypes: ['LoyaltyTiers'],
	endpoints: (builder) => ({
		getLoyaltyTiers: builder.query<LoyaltyTierApiResponse, void>({
			query: () => '/loyalty/tiers',
			providesTags: ['LoyaltyTiers'],
		}),
	}),
})

export const { useGetLoyaltyTiersQuery } = loyaltyApi
